module.exports = __webpack_public_path__ + "img/product-adv.8460d5c1.png";